import { render, staticRenderFns } from "./IconamoonDiscountLight.vue?vue&type=template&id=8e9d91ca"
import script from "./IconamoonDiscountLight.vue?vue&type=script&lang=js"
export * from "./IconamoonDiscountLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports